{
  "categoryCard": {
    "dropdown": {
      "translationButton": "See translations",
      "editButton": "Edit",
      "deleteButton": "Delete"
    },
    "questionsCount": "{{questionCount}} questions",
    "noQuestions": "No questions yet",
    "exploreQuestionsButton": "Explore other questions",
    "addQuestionsButton": "Add questions",
    "lastAskedText": "Last asked",
    "notAskedText": "Wasn’t asked yet",
    "satisfactionScoreText": "Satisfaction score"
  },
  "teamPerformanceCard": {
    "comparedToAverage": {
      "more": "more than company average",
      "less": "less than company average",
      "same": "same as company average"
    },
    "companyBaseline": "Company baseline {{score}}",
    "notEnoughResponses": "Not enough responses"
  },
  "insightsCard": {
    "responseCount": "{{responseCount}} responses"
  },
  "integrationCard": {
    "status": {
      "connected": {
        "verified": "Verified",
        "configured": "Configured",
        "connected": "Connected",
        "managed": "Managed"
      },
      "notConnected": {
        "verify": "Verify",
        "configure": "Configure",
        "connect": "Connect",
        "manage": "Manage"
      }
    },
    "connected": "Connected",
    "not_connected": "Not connected"
  },
  "questionHistoryRow": {
    "responseCount_one": "{{formattedResponses}} response",
    "responseCount_other": "{{formattedResponses}} responses",
    "insufficientResponses": "Insufficient responses",
    "questionButton": "See details"
  },
  "manageCategoryPopup": {
    "title": "Step 1/2",
    "buttonNewCategory": "Add new category",
    "buttonEditCategory": "Edit category",
    "changeButton": "Change icon",
    "nextStep": "Next step",
    "cancelButton": "Cancel",
    "inputs": {
      "categoryPlaceholder": "Enter category name",
      "categoryLabel": "Category name",
      "descriptionPlaceholder": "Enter description",
      "descriptionLabel": "Description"
    }
  },
  "manageQuestionPopup": {
    "title": "Step 1/2",
    "buttonNewQuestion": "Add new question",
    "buttonEditQuestion": "Edit question",
    "nextStep": "Next step",
    "cancelButton": "Cancel",
    "hintText": "Question responses are Agree, Somewhat agree, Neutral, Somewhat disagree, Disagree",
    "inputs": {
      "questionPlaceholder": "Enter question"
    }
  },
  "translationManageQuestion": {
    "title": "Step 2/2",
    "checkTitle": "Check translation to other languages",
    "useAITrans": "We use AI translation, so the result can have mistakes",
    "backButton": "Go back",
    "addQuestion": "Add question",
    "editQuestion": "Edit question"
  },
  "editTranslationQuestion": {
    "title": "Edit translation",
    "inputPlaceholder": "Enter category name",
    "hintText": "Question responses are Agree, Somewhat agree, Neutral, Somewhat disagree, Disagree",
    "cancelButton": "Cancel",
    "saveButton": "Save changes"
  },
  "iconPickerCategoryPopup": {
    "buttons": {
      "backButton": "Go back",
      "choseIconButton": "Choose icon for category"
    },
    "categories": {
      "performance": "Performance",
      "communication": "Communication",
      "teamCulture": "Team Culture",
      "learning": "Learning"
    }
  },
  "translationOverviewCategory": {
    "title": "Step 2/2",
    "description": "Check translation to other languages",
    "subtitle": "We use AI translation, so the result can have mistakes",
    "buttons": {
      "backButton": "Go back",
      "buttonNewCategory": "Add category",
      "buttonEditCategory": "Edit category"
    },
    "categoryNameText": "Category name",
    "descriptionText": "Description"
  },
  "changeQuestionPopup": {
    "title": "Change question",
    "buttons": {
      "cancelButton": "Cancel",
      "changeButton": "Change question"
    },
    "inputs": {
      "labelCategory": "Category",
      "placeholderCategory": "Select category",
      "labelQuestion": "Question",
      "placeholderQuestion": "Select question"
    },
    "questionHistory": {
      "lastAskedHint": "Last asked {{date}}",
      "empty": "(Empty)"
    },
    "errors": {
      "updateFailed": "Failed to update schedule question. Please try again."
    }
  },
  "blocksSidebar": {
    "placeholder": "Search blocks",
    "filters": {
      "all": "All",
      "text": "Text",
      "numbers": "Numbers",
      "graphs": "Graphs"
    }
  },
  "dashboardSidebar": {
    "role": "Role",
    "profileSettings": "Profile settings",
    "signOut": "Sign out",
    "powered": "Powered by"
  },
  "changeIndicator": {
    "noChange": "No change"
  },
  "button": {
    "clear": "Clear"
  },
  "categoryDistributionCard": {
    "questionsCount_one": "{{count}} question",
    "questionsCount_other": "{{count}} questions"
  },
  "gaugeChart": {
    "enpsScore": "eNPS score"
  },
  "pieChartSimple": {
    "previously": "{{companyScore}}% previously",
    "companyBaseline": "Company Baseline:"
  },
  "tagList": {
    "noTags": "No tags"
  },
  "surveyCard": {
    "dropdown": {
      "edit": "Edit",
      "delete": "Delete"
    },
    "useTemplate": "Use template",
    "preview": "Preview"
  },
  "translationOverviewQuestion": {
    "questionNameText": "Question name"
  },
  "calendar": {
    "cancel": "Cancel",
    "apply": "Apply"
  },
  "categoryPopup": {
    "translationEditItem": {
      "title": "Edit translation",
      "cancel": "Cancel",
      "save": "Save changes"
    }
  },
  "shareReportPopup": {
    "title": "Share report",
    "accessReport": "Access to report",
    "anyoneWithLink": "Anyone with the link",
    "copyLink": "Copy link"
  },
  "surveyBuilderPopup": {
    "surveyInfoPopup": {
      "title": "Edit translation",
      "tags": "Tags",
      "cancel": "Cancel",
      "save": "Save changes"
    },
    "surveyPublishPopup": {
      "title": "Publish a survey",
      "surveyTitle": "Survey title",
      "surveyDescription": "Survey description",
      "tags": "Tags",
      "audienceSize": "Audience size",
      "startDate": "Start date",
      "distributionMethods": "Distribution methods",
      "cancel": "Cancel",
      "save": "Save changes"
    },
    "surveyQuestionPopup": {
      "title": "Edit translation",
      "options": "Options",
      "cancel": "Cancel",
      "save": "Save changes"
    }
  },
  "userManagementRow": {
    "seeDetails": "See details",
    "leaderTag": "Leader",
    "roleChangeNotAllowed": "Only administrators can change user roles."
  },
  "errorScreen": {
    "notFound": {
      "title": "Page not found",
      "description": "Looks like this page has moved or no longer exists. Let's get you back on track - head to the Overview or return to previous page.",
      "secondaryCta": "Go to previous page",
      "primaryCta": "Go to Overview"
    },
    "generic": {
      "title": "Something didn't go as expected",
      "description": "We're already working to restore everything. Give it another try, or head back to continue where things are running smoothly.",
      "secondaryCta": "Try again",
      "primaryCta": "Go back"
    }
  },
  "deliveryPausedBanner": {
    "title": "Question delivery is paused",
    "description": {
      "manual": "Your question delivery is currently on hold. Contact support for more information.",
      "subscription_canceled": "Your subscription has been canceled and question delivery has stopped. Contact support to reactivate.",
      "subscription_past_due": "We were unable to process your payment. Question delivery is on hold until payment is updated.",
      "subscription_unpaid": "Your payment is overdue and question delivery has been suspended. Contact support to resolve.",
      "subscription_paused": "Your subscription is paused and question delivery is on hold. Contact support to resume."
    },
    "contactSupport": "Contact support"
  },
  "globalBanner": {
    "dismissFailed": "Could not save your choice. Please try again."
  },
  "setupIncompleteBanner": {
    "title": "Complete setup to start getting feedback",
    "description": "Set up your organization to start gathering team insights. It takes less than 15 minutes.",
    "completeSetupMessage": "Complete setup"
  }
}
